const routes = [
  {
    path: '/provider/appointmentManagement',
    component: () =>
      import('@/views/provider/appointmentManagement/Wrapper.vue'),
    children: [
      {
        path: '/provider/appointmentManagement',
        name: 'AppointmentManagement',
        component: () =>
          import(
            '@/views/provider/appointmentManagement/AppointmentManagementWrapper.vue'
          ),
      },
      {
        path: 'coordination/:id',
        name: 'AppoinmentCoordination',
        component: () =>
          import(
            '@/views/provider/appointmentManagement/AppointmentCoordinationWrapper.vue'
          ),
        props: {
          default: true,
        },
      },
      {
        path: '/provider/appointmentManagement/historical/:client',
        name: 'AppointmentHistorical',
        component: () =>
          import(
            '@/views/provider/appointmentManagement/AppointmentHistoricalWrapper.vue'
          ),
      },
      {
        path: '/provider/appointmentComplete/:clientAppointmentId',
        name: 'AppointmentComplete',
        component: () =>
          import(
            '@/views/provider/appointmentManagement/AppointmentCompleteWrapper.vue'
          ),
      },
      {
        path: '/provider/appointmentNewSpaceCoordination/:clientAppointmentId',
        name: 'AppointmentNewSpaceCoordination',
        component: () =>
          import(
            '@/views/provider/appointmentManagement/AppointmentNewSpaceCoordinationWrapper.vue'
          ),
      },
      {
        path: '/provider/speechAndLanguage/:clientAppointmentId',
        name: 'SpeechAndLanguage',
        component: () =>
          import(
            '@/views/provider/appointmentManagement/SpeechAndLanguageWrapper.vue'
          ),
      },
      {
        path: '/provider/speechAndLanguage/:clientAppointmentId/annexes',
        name: 'SpeechAndLanguageAnnexes',
        component: () =>
          import(
            '@/views/provider/appointmentManagement/SpeechAndLanguageAnnexesWrapper.vue'
          ),
      },
      {
        path: '/provider/specialistCertificationFinding',
        name: 'SpecialistCertificationFinding',
        component: () =>
          import(
            '@/views/provider/appointmentManagement/SpecialistCertificationFindingWrapper.vue'
          ),
      },
    ],
  },
];

export default routes;
